export const defaultNotificationState = {
	NotificationList: [],
	notificationLoaded: false,
	TotalList: 0,
	countIsNewNumber: 0,
	notifToken: null,
	notifTokenExpiry: null,
	// MISA Notification In-App v2 đang hiển thị (ưu tiên ẩn banner license)
	misaNotifShowing: false
};

export default {
	...defaultNotificationState
};
